import { FileText, Mail, Send, Settings, ShoppingCart, Truck, User } from "react-feather";

export const LanguagesData = [
  { data: "en", icon: "us", language: "English" },
  { data: "du", icon: "de", language: "Deutsch" },
  { data: "es", icon: "es", language: "Español" },
  { data: "fr", icon: "fr", language: "Français" },
  { data: "pt", icon: "pt", language: "Português" },
  { data: "cn", icon: "cn", language: "简体中文" },
  { data: "ae", icon: "ae", language: "لعربية" },
];

export const CartHeaderData = [
  { id: 1, image: "06.jpg", name: "Men Jacket", price: 299.00, quantity: 1 },
  { id: 2, image: "02.jpg", name: "Women Top", price: 150.00, quantity: 2 },
];

export const BookMarkData = [
  { icon: "form", title: "Forms", url: `${process.env.PUBLIC_URL}/forms/form-controls/form-validation` },
  { icon: "user", title: "Profile", url: `${process.env.PUBLIC_URL}/applications/users/user-profile` },
  { icon: "table", title: "Tables", url: `${process.env.PUBLIC_URL}/table/reactstrap-tables/basic-table` },
];

export const NotiticationsData = [
  { id: 1, color: "primary", name: "Delivery processing", time: "10 min." , href:`${process.env.PUBLIC_URL}/applications/ecommerce/order-history` ,icon:<Truck className={`stroke-primary`} />},
  { id: 2, color: "secondary", name: "Order Complete", time: "1 hr.", href:`${process.env.PUBLIC_URL}/applications/ecommerce/cart` ,icon:<ShoppingCart className={`stroke-secondary`} /> },
  { id: 3, color: "success", name: "Tickets Generated", time: "3 hr.", href:`${process.env.PUBLIC_URL}/applications/ecommerce/invoice/invoice-6` ,icon:<FileText className={`stroke-success`} /> },
  { id: 4, color: "warning", name: "Delivery Complete", time: "6 hr.", href:`${process.env.PUBLIC_URL}/applications/email/letter-box` ,icon:<Send className={`stroke-warning`} /> },
];

export const MessageBoxData =[
  {image:"user/3.jpg",title:"Helen Walter",text:"Do you want to go see movie?"},
  {image:"user/6.jpg",title:"Jason Borne",text:"Thank you for rating us."},
  {image:"user/10.jpg",title:"Sarah Loren",text:"What`s project report update?"},
]

export const ProfileHeaderData = [
  { id: 1, link: `applications/users/user-profile`, icon: <User/>, text: "Account" },
  { id: 2, link: `applications/email/letter-box`, icon: <Mail/>, text: "Inbox" },
  { id: 3, link: `applications/task`, icon: <FileText/>, text: "Taskboard" },
  { id: 4, link: `applications/users/edit-profile`, icon: <Settings/>, text: "Settings" },
];